import { Components, dialogClasses, Theme } from '@mui/material'

export const MuiDialog: Components<Omit<Theme, 'components'>>['MuiDialog'] = {
  defaultProps: {
    maxWidth: 'sm',
    fullWidth: true,
  },
  variants: [
    {
      // fullScreen sets its own edge-to-edge sizing, which this must not override.
      props: ({ maxWidth, fullScreen }) => maxWidth === 'xxl' && !fullScreen,
      style: ({ theme }) => {
        const immersiveInset = theme.spacing(3)
        return {
          [`& .${dialogClasses.paper}`]: {
            margin: immersiveInset,
            // MUI sizes the paper against its own margin, so each dimension restates the inset.
            width: `calc(100% - ${immersiveInset} * 2)`,
            height: `calc(100% - ${immersiveInset} * 2)`,
            maxHeight: `calc(100% - ${immersiveInset} * 2)`,
          },
        }
      },
    },
  ],
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.shape['radius-xl'],
      borderWidth: theme.strokeWidth.default,
      borderStyle: 'solid',
      borderColor: theme.palette.border.subtle,
      boxShadow: theme.customShadows.md,
      backgroundColor: theme.palette.bg.surface.default,
      backgroundImage: 'none', // MUI default adds a white overlay on top of the background color, this removes it
    }),
  },
}

export const MuiDialogTitle: Components<Omit<Theme, 'components'>>['MuiDialogTitle'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography['display-h3'],
      color: theme.palette.text.default,
      padding: theme.spacing(3, 4, 0, 5),
      display: 'flex',
    }),
  },
}

export const MuiDialogContent: Components<Omit<Theme, 'components'>>['MuiDialogContent'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(5),
      '.MuiDialogTitle-root + &': {
        paddingTop: theme.spacing(3),
      },
    }),
  },
}

export const MuiDialogContentText: Components<Omit<Theme, 'components'>>['MuiDialogContentText'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.text.default,
    }),
  },
}

export const MuiDialogActions: Components<Omit<Theme, 'components'>>['MuiDialogActions'] = {
  defaultProps: {
    disableSpacing: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.bg.surface.subtle,
      borderTopWidth: theme.strokeWidth.default,
      borderTopStyle: 'solid',
      borderTopColor: theme.palette.border.subtle,
      padding: theme.spacing(4),
      gap: theme.spacing(1.5),
    }),
  },
}
